// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@fontface {
	font-family: 'Roboto', sans-serif;
	src: url('https://fonts.googleapis.com/css?family=Roboto:300,400,500,700&display=swap');
}

.registration-component-wrapper {
	font-family: 'Roboto', sans-serif;
}

.reg-form {
	box-sizing: border-box;
	text-align: center;
}

.reg-form .error-text {
	position: absolute;
	color: #ff0000;
	font-size: 12px;
	left: 0;
	right: 0;
	margin: 3px auto auto;
}

.reg-form input {
	width: 100%;
	box-sizing: border-box;
	height: 48px;
	border: 0;
	border: 1px solid #828282;
	text-align: center;
	font-size: 15px;
    border-radius: 999px;
}

.reg-form input:focus {
	outline: none !important;
}

.reg-form .form-submit {
	height: 48px;
	font-size: 23px;
	font-weight: 600;
	background: 0 0;
	border: 2px solid;
	color: #fff;
	border-radius: 30px;
	text-transform: uppercase;
    background:rgb(30, 195, 30);
	cursor: pointer;
}

.reg-form .form-submit.disabled {
	opacity: 0.3;
}

.reg-form .form-submit:hover {
	background:#18ad18;
}

.reg-form .input-with-validation {
	margin-bottom: 30px;
	position: relative;
}

.passwordEye {
    width: 17px;
    position: absolute;
    cursor: pointer;
    top: 16px;
    right: 11px;
    opacity: 0.6;
}

.reg-form .suggestions {
    margin-top: 24px;
    margin-bottom: 15px;
}

.reg-form .suggestions div {
    font-size: 15px;
    border: 1px solid #000;
    border-radius: 15px;
    cursor: pointer;
    display: inline-block;
    padding: 3px 7px;
    margin: 0 3px;
}

.reg-form .suggestions div:hover {
    border: 1px solid #757373;
    color: #757373;
}

.reg-form .suggestions-shown {
	margin-bottom: 0;
}

.registration-component-wrapper .success-message h1{
	font-size: 16px;
	text-align: center;
	font-weight: 500;
}

.registration-component-wrapper .success-message {
	text-align: center;
}

.registration-component-wrapper a {
	color: #000;
}

.registration-component-wrapper iframe {
	visibility: hidden;
}

@media only screen and (max-width: 374px) {
	.reg-form {
		padding: 0 20px;
	}
}
`, "",{"version":3,"sources":["webpack://./Content/Css/Components/registrationForm.css"],"names":[],"mappings":"AAAA;CACC,iCAAiC;CACjC,uFAAuF;AACxF;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,sBAAsB;CACtB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,eAAe;CACf,OAAO;CACP,QAAQ;CACR,qBAAqB;AACtB;;AAEA;CACC,WAAW;CACX,sBAAsB;CACtB,YAAY;CACZ,SAAS;CACT,yBAAyB;CACzB,kBAAkB;CAClB,eAAe;IACZ,oBAAoB;AACxB;;AAEA;CACC,wBAAwB;AACzB;;AAEA;CACC,YAAY;CACZ,eAAe;CACf,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,WAAW;CACX,mBAAmB;CACnB,yBAAyB;IACtB,2BAA2B;CAC9B,eAAe;AAChB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,kBAAkB;AACnB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,SAAS;IACT,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;IACf,qBAAqB;IACrB,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC;EACC,eAAe;CAChB;AACD","sourcesContent":["@fontface {\r\n\tfont-family: 'Roboto', sans-serif;\r\n\tsrc: url('https://fonts.googleapis.com/css?family=Roboto:300,400,500,700&display=swap');\r\n}\r\n\r\n.registration-component-wrapper {\r\n\tfont-family: 'Roboto', sans-serif;\r\n}\r\n\r\n.reg-form {\r\n\tbox-sizing: border-box;\r\n\ttext-align: center;\r\n}\r\n\r\n.reg-form .error-text {\r\n\tposition: absolute;\r\n\tcolor: #ff0000;\r\n\tfont-size: 12px;\r\n\tleft: 0;\r\n\tright: 0;\r\n\tmargin: 3px auto auto;\r\n}\r\n\r\n.reg-form input {\r\n\twidth: 100%;\r\n\tbox-sizing: border-box;\r\n\theight: 48px;\r\n\tborder: 0;\r\n\tborder: 1px solid #828282;\r\n\ttext-align: center;\r\n\tfont-size: 15px;\r\n    border-radius: 999px;\r\n}\r\n\r\n.reg-form input:focus {\r\n\toutline: none !important;\r\n}\r\n\r\n.reg-form .form-submit {\r\n\theight: 48px;\r\n\tfont-size: 23px;\r\n\tfont-weight: 600;\r\n\tbackground: 0 0;\r\n\tborder: 2px solid;\r\n\tcolor: #fff;\r\n\tborder-radius: 30px;\r\n\ttext-transform: uppercase;\r\n    background:rgb(30, 195, 30);\r\n\tcursor: pointer;\r\n}\r\n\r\n.reg-form .form-submit.disabled {\r\n\topacity: 0.3;\r\n}\r\n\r\n.reg-form .form-submit:hover {\r\n\tbackground:#18ad18;\r\n}\r\n\r\n.reg-form .input-with-validation {\r\n\tmargin-bottom: 30px;\r\n\tposition: relative;\r\n}\r\n\r\n.passwordEye {\r\n    width: 17px;\r\n    position: absolute;\r\n    cursor: pointer;\r\n    top: 16px;\r\n    right: 11px;\r\n    opacity: 0.6;\r\n}\r\n\r\n.reg-form .suggestions {\r\n    margin-top: 24px;\r\n    margin-bottom: 15px;\r\n}\r\n\r\n.reg-form .suggestions div {\r\n    font-size: 15px;\r\n    border: 1px solid #000;\r\n    border-radius: 15px;\r\n    cursor: pointer;\r\n    display: inline-block;\r\n    padding: 3px 7px;\r\n    margin: 0 3px;\r\n}\r\n\r\n.reg-form .suggestions div:hover {\r\n    border: 1px solid #757373;\r\n    color: #757373;\r\n}\r\n\r\n.reg-form .suggestions-shown {\r\n\tmargin-bottom: 0;\r\n}\r\n\r\n.registration-component-wrapper .success-message h1{\r\n\tfont-size: 16px;\r\n\ttext-align: center;\r\n\tfont-weight: 500;\r\n}\r\n\r\n.registration-component-wrapper .success-message {\r\n\ttext-align: center;\r\n}\r\n\r\n.registration-component-wrapper a {\r\n\tcolor: #000;\r\n}\r\n\r\n.registration-component-wrapper iframe {\r\n\tvisibility: hidden;\r\n}\r\n\r\n@media only screen and (max-width: 374px) {\r\n\t.reg-form {\r\n\t\tpadding: 0 20px;\r\n\t}\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
